import React, { useContext } from 'react'
import TypographyContext from 'app/react/components/typography/TypographyContext'
import Font from 'app/react/components/typography/Font'

export default function Fonts () {

  const { fonts } = useContext(TypographyContext)

  if (fonts.length === 0) return

  return (
    <div className="dm-typography__fonts">
      {fonts.map((font, i) => <Font key={i} {...font} />)}
    </div>
  )
}